import { Burger, Flex, Group, Input } from '@mantine/core';

import { ProfileMenu } from './ProfileMenu';

export const Header = ({ toggleMenu, opened }: { toggleMenu: () => void; opened: boolean }) => {
  return (
    <Flex
      bg={{ base: 'var(--mantine-color-sidebar-context-filled)', md: 'var(--mantine-color-body)' }}
      w="100%"
      justify="space-between"
      align="center"
      p="sm"
      style={{ boxShadow: '0px 4px 10px 0 rgba(0, 0, 0, 0.03)' }}
    >
      <Burger
        c="white"
        opened={opened}
        onClick={toggleMenu}
        hiddenFrom="sm"
        size="sm"
      />
      <Input
        disabled
        placeholder="Search"
        bg="var(--mantine-color-body)"
        w="280px"
      />
      <Group>
        <div />
        <ProfileMenu />
      </Group>
    </Flex>
  );
};
